import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const setAdminToken = (token) => {
  if (token) {
    localStorage.setItem("admin_token", token);
    api.defaults.headers.common["X-Admin-Token"] = token;
  } else {
    localStorage.removeItem("admin_token");
    delete api.defaults.headers.common["X-Admin-Token"];
  }
};

const existing = typeof window !== "undefined" ? localStorage.getItem("admin_token") : null;
if (existing) api.defaults.headers.common["X-Admin-Token"] = existing;

export const getAdminToken = () =>
  typeof window !== "undefined" ? localStorage.getItem("admin_token") : null;
